import { Button, Typography } from "@material-ui/core"
import { SingleServiceCenter } from "api"
import Image from "next/image"
import styled from "styled-components"
import { StyledCol, StyledRow, StyledSvgIcon } from "theme/shared"
import CardRowText from "../../CardRowText"
import SocialIconButton from "./SocialIconButton"
const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  ${(p) => p.theme.breakpoints.up("md")} {
    flex-direction: row;
    gap: 100px;
  }
`
const StyledCarHeadline = styled(Typography).attrs({ variant: "h1" })`
  text-align: start;
  font-size: 24px;
  font-weight: 400;
`
const StyledHeadline = styled(Typography).attrs({ variant: "h3" })`
  margin-top: 0;
  display: inline-block;
`
const StyledImageWrap = styled.div`
  width: 140px;
  height: 110px;
  border: 0.53125px solid ${(p) => p.theme.colors.darkGrey};
  border-radius: 8.5px;
  overflow: hidden;
  margin-bottom: 8px;
`
type CenterProfileProps = {
  centerData: SingleServiceCenter
  openTreatmentFunc: () => void
  openContentUsFunc: () => void
}

const CenterProfile = ({
  centerData,
  openTreatmentFunc,
  openContentUsFunc,
}: CenterProfileProps) => {
  return (
    <StyledWrapper>
      {/* col1: */}
      <StyledCol $notCenter>
        {centerData?.logo?.imageUrl && (
          <StyledImageWrap>
            <Image
              src={centerData?.logo.imageUrl}
              alt={"דלק מוטורס"}
              width={140}
              height={110}
              objectFit="contain"
              priority
            />
          </StyledImageWrap>
        )}
        <StyledCarHeadline>{centerData?.name}</StyledCarHeadline>
        <StyledRow $gap="15px" $fullWidth $mt="20px">
          <Button
            onClick={() => {
              openTreatmentFunc()
            }}
          >
            קביעת ביקור
          </Button>
          <Button
            onClick={() => {
              openContentUsFunc()
            }}
            variant="outlined"
          >
            יצירת קשר
          </Button>
        </StyledRow>
      </StyledCol>
      {/* col2: */}
      <StyledCol $gap="15px" $fullWidth $notCenter>
        <CardRowText
          data={centerData.address}
          iconName="mazdaLocationIcon"
          imageAlt={"מיקום"}
        />
        <CardRowText
          data={centerData.whatsapp}
          link={centerData.whatsappLink}
          iconName="whatsappLogo"
          imageAlt="ווטסאפ"
        />
        <CardRowText
          data={centerData.phone}
          link={`tel:${centerData.phone}`}
          iconName="phoneCall"
          imageAlt="טלפון"
        />
        <CardRowText data={centerData.fax} iconName="fax" imageAlt="פקס" />
        <CardRowText
          data={centerData.email}
          link={`mailto:${centerData.email}`}
          iconName="mailIcon"
          imageAlt="מייל"
        />
      </StyledCol>
      {/* col3 */}
      {centerData?.workingSchedule && (
        <StyledCol $notCenter $fullWidth>
          <StyledRow $gap="12px">
            <StyledSvgIcon
              src={`/icons/clock.svg`}
              alt="שעות פעילות"
              w={20}
              h={20}
            />
            <StyledHeadline>שעות פעילות</StyledHeadline>
          </StyledRow>
          {Object.entries(centerData.workingSchedule).map(([time, days], i) => (
            <StyledRow key={i} $mt="5px">
              <CardRowText data={`${[...days].join(", ")} : ${time}`} />
            </StyledRow>
          ))}
          {(centerData.siteName ||
            centerData.twitter ||
            centerData.instegram ||
            centerData.facebook) && (
            <StyledRow $mt="17px" $gap="10px">
              <StyledHeadline>בקרו אותנו</StyledHeadline>
              <SocialIconButton
                link={centerData.siteName}
                iconName="social/website"
                alt={"website icon"}
              />
              <SocialIconButton
                link={centerData.twitter}
                iconName="social/twitter"
                alt={"twitter icon"}
              />
              <SocialIconButton
                link={centerData.instegram}
                iconName="social/insta"
                alt={"instagram icon"}
              />
              <SocialIconButton
                link={centerData.facebook}
                iconName="social/facebook"
                alt={"facebook icon"}
              />
            </StyledRow>
          )}
        </StyledCol>
      )}
    </StyledWrapper>
  )
}

export default CenterProfile
